import 'katex/dist/katex.min.css'
import MarkdownPage from "./MarkdownPage";

type MessagesProps = {} & React.HTMLAttributes<HTMLDivElement>;

export default function MessagesPage({ children, ...props }: MessagesProps) {
  return (
    <MarkdownPage group={"announces"} message={"post"}></MarkdownPage>
  )
}
